import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { RefreshCw } from 'react-feather';

type Props = {
  className?: string;
  label?: string;
  refreshing: boolean;
  disabled?: boolean;
  onClick: () => void;
};

export function RefreshButton({
  className,
  label = 'Refresh',
  refreshing,
  disabled,
  onClick,
}: Props): React.ReactElement {
  return (
    <Root className={className} refreshing={refreshing} disabled={disabled ?? refreshing} onClick={onClick}>
      <span>{label}</span>
      <StyledIcon refreshing={refreshing} strokeWidth={3} />
    </Root>
  );
}

type RootProps = {
  disabled?: boolean;
  refreshing: boolean;
};

const Root = styled('button', {
  shouldForwardProp: (prop) => !['disabled', 'refreshing'].includes(prop),
})<RootProps>(({ disabled, refreshing }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  color: disabled && !refreshing ? 'var(--gray-l)' : '#5C73AD',
  cursor: disabled ? 'not-allowed' : 'pointer',
}));

const spin = keyframes({
  '0%': { transform: 'rotate(0deg)' },
  '100%': { transform: 'rotate(360deg)' },
});

type IconProps = {
  refreshing: boolean;
};

const StyledIcon = styled(RefreshCw, {
  shouldForwardProp: (prop) => prop !== 'refreshing',
})<IconProps>(({ refreshing }) => ({
  animationName: refreshing ? spin : undefined,
  animationDuration: refreshing ? '800ms' : undefined,
  animationIterationCount: refreshing ? 'infinite' : undefined,
  animationTimingFunction: refreshing ? 'linear' : undefined,
}));
